module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.block]
  }, [(_vm.numbered) ? _c('div', {
    class: [_vm.block + '-number']
  }, [_vm._v("\n    " + _vm._s(_vm.index + 1) + ".\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'bm-pressed': _vm.pressed, 'm-large': _vm.size == 'large'
    },
    on: {
      "mousedown": _vm.mouseDown,
      "mouseup": _vm.mouseUp,
      "mouseleave": _vm.mouseLeave
    }
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e6ca393","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/blocks/TocIndex.vue
// module id = 453
// module chunks = 0